import { BotSkill } from "./Types";


export class GameConstants {

    public static readonly VERSION = "ALPHA 0.1.0";

    public static readonly DEVELOPMENT = false;
    public static readonly MUTE_AUDIO = true;
    public static readonly VALID_DOMAINS: string[] = [];
    public static readonly SAVED_GAME_DATA_KEY = "euchre-game-data";

    public static readonly GAME_WIDTH_PORTRAIT = 900;
    public static readonly GAME_HEIGHT_PORTRAIT = 1200;
    public static readonly GAME_WIDTH_LANDSCAPE = 1600;
    public static readonly GAME_HEIGHT_LANDSCAPE = 900;

    public static readonly BOT_PROFILES: BotProfile[] = [
        { id: 1, name: "James", skill: BotSkill.LOW },
        { id: 2, name: "Manolo", skill: BotSkill.LOW },
        { id: 3, name: "Takeshi", skill: BotSkill.MEDIUM },
        { id: 4, name: "Pablo", skill: BotSkill.MEDIUM },
        { id: 5, name: "George", skill: BotSkill.HIGH },
        { id: 6, name: "Mahmud", skill: BotSkill.HIGH },
        { id: 7, name: "Patrick", skill: BotSkill.MEDIUM },
        { id: 8, name: "Helmut", skill: BotSkill.HIGH },
        { id: 9, name: "Pietro", skill: BotSkill.LOW },
        { id: 10, name: "Krishna", skill: BotSkill.MEDIUM },
        { id: 11, name: "Noam", skill: BotSkill.HIGH },
        { id: 12, name: "Antoine", skill: BotSkill.LOW },
        { id: 13, name: "Elisabeth", skill: BotSkill.MEDIUM },
        { id: 14, name: "Alice", skill: BotSkill.LOW },
        { id: 15, name: "Chloe", skill: BotSkill.LOW },
        { id: 16, name: "Anouk", skill: BotSkill.MEDIUM },
        { id: 17, name: "Saanvi", skill: BotSkill.MEDIUM },
        { id: 18, name: "Rose", skill: BotSkill.HIGH },
        { id: 19, name: "Mia", skill: BotSkill.HIGH },
        { id: 20, name: "Mei", skill: BotSkill.HIGH },
        { id: 21, name: "Aisha", skill: BotSkill.LOW },
        { id: 22, name: "Macarena", skill: BotSkill.MEDIUM },
        { id: 23, name: "Tori", skill: BotSkill.HIGH },
        { id: 24, name: "Janaina", skill: BotSkill.LOW }
    ];

    public static readonly TEXT_COLOR = "#f9efde";
    public static readonly LOCAL_PLAYER = 0;
    public static readonly PLAYER_NAMES = ["You", "West", "North", "East"] as const;
    public static readonly TEAM_NAMES = ["You + North", "West + East"] as const;
}